export default __webpack_public_path__ + "assets/tkoGlamourShot.5725b594.jpg";